var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-admin"},[_c('v-container',{staticClass:"footer-container d-flex align-center justify-center"},[_c('span',{staticClass:"footer-text"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" ELSONIII — All rights reserved. ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }